import React from 'react'
import SimpleTable from 'components/Tables/SimpleTable'

export default ({ node }) => <div>{node.extras.message ? node.extras.message : 'No message'}</div>



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Gather/GatherDisplay.jsx